export default "__VITE_ASSET__C$HRHq1o__"